import { ConfigsLoaderService } from './shared/configs-loader.service';
import { APP_INITIALIZER, NgModule, InjectionToken } from '@angular/core';
import { IPublicClientApplication, PublicClientApplication, InteractionType, LogLevel } from '@azure/msal-browser';
import {  MsalModule, MsalService, MSAL_GUARD_CONFIG , MsalGuardConfiguration, MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG, MsalInterceptorConfiguration, MsalGuard, MsalBroadcastService, MsalInterceptor} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

const AUTH_CONFIG_URL_TOKEN = new InjectionToken<string>('AUTH_CONFIG_URL');

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

export function MSALInstanceFactory(config: ConfigsLoaderService): IPublicClientApplication {
  const authority = 'https://login.microsoftonline.com/' + config.AZURE_AD_TENENTID;
  return new PublicClientApplication({
    auth: {
      clientId: config.AZURE_AD_CLIENTID,
      authority: authority,
      redirectUri: config.AZURE_AD_REDIRECTURI,
      postLogoutRedirectUri: config.AZURE_AD_REDIRECTURI,
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: isIE,
    },
    system: {
      loadFrameTimeout: 30000,
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false
      }
    }
  });
}


export function appInitializerFactory(configsLoaderService: ConfigsLoaderService) {
  return () => configsLoaderService.loadConfigs();
}

export function MSALGuardConfigFactory(config: ConfigsLoaderService): MsalGuardConfiguration {
  return { 
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ["user.read",'openid','profile'],
    },
    loginFailedRoute: ''
  };
}

export function MSALInterceptorConfigFactory(config: ConfigsLoaderService): MsalInterceptorConfiguration {
  let SCOPE = "api://"+config.AZURE_AD_CLIENTID+"/user_impersonation";
  const protectedResourceMap = new Map<string, Array<string>>( [

    ["https://graph.microsoft.com/v1.0/me", ["user.read"]],

    ["https://graph.microsoft.com/v1.0/", ["user.read"]],
    
    [config.API_BASE_URI,[SCOPE]],
    
  ])
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}


@NgModule({
  providers: [],
  imports: [MsalModule],
})
export class MsalApplicationModule {
  static forRoot(configFile: string) {
    return {
      ngModule: MsalApplicationModule,
      providers: [
        ConfigsLoaderService,
        { provide: AUTH_CONFIG_URL_TOKEN, useValue: configFile },
        { provide: APP_INITIALIZER, useFactory: appInitializerFactory,
          deps: [ConfigsLoaderService, AUTH_CONFIG_URL_TOKEN], multi: true },
        {
            provide: MSAL_INSTANCE,
            useFactory: MSALInstanceFactory,
            deps: [ConfigsLoaderService]
        },

          {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MSALGuardConfigFactory,
            deps: [ConfigsLoaderService]
        },
        /*{
          provide: MSAL_CONFIG_ANGULAR,
          useFactory: MSALAngularConfigFactory,
        },*/
        {
          provide: MSAL_INTERCEPTOR_CONFIG,
          useFactory: MSALInterceptorConfigFactory,
          deps: [ConfigsLoaderService]
      },
      MsalService,
      MsalGuard,
      MsalBroadcastService,
      {
          provide: HTTP_INTERCEPTORS,
          useClass: MsalInterceptor,
          multi: true
      }
      ],
    };
  }
}


